export default __webpack_public_path__ + "static/layout-example-dark-770288c75be50ea819903a2f72f8eed2697781183e4830d97c6c5b9de9a38b13.png";